/**
 * トークン入力画面（SPEC §3）。
 * 初回アクセス時と 401 受信時にここへ戻る。
 */
import { useState, type ReactNode } from 'react';
import { ApiError, NetworkError, apiFetch } from '../lib/api';
import { setToken } from '../lib/token';

export function TokenGate({ onAuthenticated }: { onAuthenticated: () => void }): ReactNode {
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (): Promise<void> => {
    const token = value.trim();
    if (token === '' || busy) return;
    setBusy(true);
    setError(null);
    setToken(token);
    try {
      await apiFetch('/api/state');
      onAuthenticated();
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) setError('トークンが違います');
      else if (e instanceof NetworkError) setError('サーバに接続できません');
      else setError(e instanceof Error ? e.message : String(e));
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-dvh items-center justify-center px-6">
      <form
        className="w-full max-w-sm"
        onSubmit={(e) => {
          e.preventDefault();
          void submit();
        }}
      >
        <div className="mb-8 flex items-center gap-3">
          <img src="/icons/icon-192.png" alt="" className="size-12 rounded-xl" />
          <div>
            <h1 className="text-xl font-black tracking-tight">BURN LOG</h1>
            <p className="text-xs text-zinc-500">消耗品の在庫と月次費用</p>
          </div>
        </div>

        <label className="mb-1.5 block text-sm font-medium text-zinc-400" htmlFor="token">
          API トークン
        </label>
        <input
          id="token"
          className="field"
          type="password"
          autoComplete="current-password"
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        {error && <p className="mt-2 text-sm text-red-400">{error}</p>}

        <button type="submit" className="btn-primary mt-5 w-full" disabled={busy || value.trim() === ''}>
          {busy ? '確認中…' : '接続'}
        </button>

        <p className="mt-4 text-xs leading-relaxed text-zinc-600">
          Cloudflare Pages の Secret <code className="text-zinc-500">API_TOKEN</code> と同じ値を入力してください。
          この端末の localStorage に保存されます。
        </p>
      </form>
    </div>
  );
}
